export default "__VITE_ASSET__kuxyJYq___"